var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAffected = function SvgAffected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.999 2v2m0 3v2m0 3v2M2.19 5.327l2.925 2.25c.187.144.28.216.314.304.03.077.03.161 0 .238-.034.088-.127.16-.314.304l-2.925 2.25c-.276.212-.414.318-.53.317a.33.33 0 0 1-.257-.127c-.072-.091-.072-.265-.072-.613v-4.5c0-.348 0-.522.072-.613a.33.33 0 0 1 .257-.127c.116-.001.254.105.53.317m11.616 0-2.925 2.25c-.187.144-.28.216-.314.304a.33.33 0 0 0 0 .238c.033.088.127.16.314.304l2.925 2.25c.276.212.413.318.53.317a.33.33 0 0 0 .257-.127c.071-.091.071-.265.071-.613v-4.5c0-.348 0-.522-.071-.613a.33.33 0 0 0-.258-.127c-.116-.001-.253.105-.53.317",
    opacity: 0.7
  })));
};
export default SvgAffected;